import { RouteProps } from 'react-router';
import { ENTITY_TYPE } from 'common/constants';
import { TimesheetComponent } from 'components/Timesheet/TimesheetComponent';
import BillingReportComponent from 'components/Reports/BillingReportComponent';
import TimesheetReportComponent from 'components/Reports/TimesheetReportComponent';
import UtilizationReportComponent from 'components/Reports/UtilizationReportComponent';
import AllocationVsTimesheetReportComponent from 'components/Reports/AllocationVsTimesheetReportComponent';
import ClientDetail from 'components/Clients/ClientDetail';
import Employees from 'components/Employee/Employee';
import EmployeeDetail from 'components/Employee/EmployeeDetail';
import MyTeam from 'components/Employee/MyTeam';
import Projects from 'components/Project/Projects';
import ProjectDetail from 'components/Project/ProjectDetail';
import Providers from 'components/Provider/Providers';
import ProviderDetail from 'components/Provider/ProviderDetail';
import Workflows from 'components/Workflow/Workflows';
import UserPage from 'pages/user';
import Roles from 'components/Roles/Roles';
import RoleDetail from 'components/Roles/RoleDetail';
import Users from 'pages/users';
import TimeOff from 'components/TimeOff/TimeOff';
import Regime from 'components/TimeOff/Regime';
import RegimeTypes from 'components/TimeOff/RegimeTypes';
import TimeOffRequest from 'components/TimeOff/Request/TimeOffRequest';
import HRCalendar from 'components/TimeOff/Calendar/HRCalendar';
import HolidayPage from 'components/TimeOff/Calendar/HolidayPage';
import WorkflowAdmin from 'components/Workflow/WorkflowAdmin';
import MyInvoices from 'components/AccountsPayable/MyInvoices/MyInvoices';
import InvoicesAccountsPayable from 'components/AccountsPayable/InvoicesAccountsPayable';
import InvoiceUpload from 'components/NewInvoice/Upload/InvoiceUpload';
import CorporateEntities from 'components/CorporateEntitites/CorporateEntities';
import TranslationsPage from 'components/Translation/TranslationPage';
import CorporateEntityDetail from 'components/CorporateEntitites/CorporateEntityDetail/CorporateEntityDetail';
import { TaxList } from 'components/TaxManagement';
import InvoiceConfigurationPage from 'components/InvoiceConfiguration/InvoiceConfigurationPage';
import AccountList from 'components/AccountManagement/AccountList';
import AccountDetail from 'components/AccountManagement/AccountDetail';
import ReconciliationPage from 'components/AccountManagement/ReconciliationPage';
import { DashboardComponent } from 'components/Dashboard/DashboardComponent';
import ComponentsShowcase from 'pages/showcase/components-showcase';
import ColorsShowcase from 'pages/showcase/color-showcase';
import TypographyShowcase from 'pages/showcase/typography-showcase';
import ShowcaseDataGrid from 'pages/showcase/datagrid-showcase';
import Clients from 'components/Clients/Clients';
import Notifications from 'components/notifications/Notifications';
import MyInvoiceDetail from 'components/AccountsPayable/MyInvoices/MyInvoiceDetail';
import Invoicing from 'components/Invoicing/Invoicing';
import EditRegimeType from 'components/TimeOff/EditRegimeType';
import NewRegimeType from 'components/TimeOff/newRegimeType';
import RegimeNew from 'components/TimeOff/RegimeNew';
import InvoiceDetailAccountsPayable from 'components/AccountsPayable/Detail/InvoiceDetailAccountsPayable';
import InvoicingDetail from 'components/Invoicing/Detail/InvoicingDetail';
import NewInvoicing from 'components/NewInvoice/NewInvoicing';
import { NotificationConfiguration } from 'components/notifications/Configuration';
import InvoiceTypeList from 'components/InvoiceTypeManagement/InvoiceTypeList';
import ScopeList from 'components/Scopes/ScopeList';
import ScopeDetail from 'components/Scopes/ScopeDetail';
import FunctionalityList from 'components/Functionalities/FunctionalityList';
import FunctionalityDetail from 'components/Functionalities/FunctionalityDetail';
import ScopeFunctionalityMatrix from 'components/Functionalities/ScopeFunctionalityMatrix';
import UnreconciledInvoicesReportComponent from 'components/Reports/UnreconciledInvoicesReportComponent';
import AiCreditPage from 'components/AiCredit/AiCreditPage';
import SkillsPage from 'components/HumanResources/Skills/SkillsPage';
import TrainingCertificationsPage from 'components/HumanResources/TrainingCertifications/TrainingCertificationsPage';
import TrainingCoursesPage from 'components/HumanResources/TrainingCourses/TrainingCoursesPage';
import ProfilesPage from 'components/HumanResources/Profiles/ProfilesPage';
import JobOpeningsPage from 'components/HumanResources/JobOpenings/JobOpeningsPage';
import SkillMatrixPage from 'components/HumanResources/SkillMatrix/SkillMatrixPage';
import MySkillsPage from 'components/HumanResources/MySkills/MySkillsPage';
import CvConfigurationPage from 'components/HumanResources/CvConfiguration/CvConfigurationPage';

export type RoutePermissionDefinition = RouteProps & {
  scopes?: string[];
  entityTypes?: ENTITY_TYPE[];
  identifier?: string;
};

const ROUTES: RoutePermissionDefinition[] = [
  {
    path: '/',
    element: <DashboardComponent />,
    entityTypes: [ENTITY_TYPE.ANY],
  },
  {
    path: '/clients',
    element: <Clients />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/client/new',
    element: <ClientDetail />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/client/detail/:id',
    element: <ClientDetail />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/projects',
    element: <Projects />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/project/new',
    element: <ProjectDetail />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/project/detail/:idProject',
    element: <ProjectDetail />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/employees',
    element: <Employees />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/employee/new',
    element: <EmployeeDetail />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/employee/detail/:id',
    element: <EmployeeDetail />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/myteam',
    element: <MyTeam />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/timesheet',
    element: <TimesheetComponent />,
    entityTypes: [ENTITY_TYPE.ANY],
  },
  {
    path: '/reports/billing',
    element: <BillingReportComponent />,
    entityTypes: [ENTITY_TYPE.ANY],
  },
  {
    path: '/reports/timesheet',
    element: <TimesheetReportComponent />,
    entityTypes: [ENTITY_TYPE.ANY],
  },
  {
    path: '/reports/unreconciled-invoices',
    element: <UnreconciledInvoicesReportComponent mode="ar" />,
    entityTypes: [ENTITY_TYPE.ANY],
  },
  {
    path: '/reports/unreconciled-ap',
    element: <UnreconciledInvoicesReportComponent mode="ap" />,
    entityTypes: [ENTITY_TYPE.ANY],
  },
  {
    path: '/reports/utilization',
    element: <UtilizationReportComponent />,
    entityTypes: [ENTITY_TYPE.ANY],
  },
  {
    path: '/reports/allocation-vs-timesheet',
    element: <AllocationVsTimesheetReportComponent />,
    entityTypes: [ENTITY_TYPE.ANY],
  },
  {
    path: '/reports/billing/client',
    element: <BillingReportComponent client />,
    entityTypes: [ENTITY_TYPE.CLIENT, ENTITY_TYPE.ANY],
  },
  {
    path: '/reports/timesheet/client',
    element: <TimesheetReportComponent client />,
    entityTypes: [ENTITY_TYPE.CLIENT, ENTITY_TYPE.ANY],
  },
  {
    path: '/providers',
    element: <Providers />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE, ENTITY_TYPE.ANY],
  },
  {
    path: '/provider/new',
    element: <ProviderDetail />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE, ENTITY_TYPE.ANY],
  },
  {
    path: '/provider/detail/:id',
    element: <ProviderDetail />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE, ENTITY_TYPE.ANY],
  },
  {
    path: '/users',
    element: <Users />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE, ENTITY_TYPE.ANY],
  },
  {
    path: '/user/new',
    element: <UserPage />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE, ENTITY_TYPE.ANY],
  },
  {
    path: '/user/detail/:id',
    element: <UserPage />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE, ENTITY_TYPE.ANY],
  },
  {
    path: '/roles',
    element: <Roles />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE, ENTITY_TYPE.ANY],
  },
  {
    path: '/role/new',
    element: <RoleDetail />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE, ENTITY_TYPE.ANY],
  },
  {
    path: '/role/detail/:id',
    element: <RoleDetail />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE, ENTITY_TYPE.ANY],
  },
  {
    path: '/scopes',
    element: <ScopeList />,
    identifier: 'ui.admin.scopes',
    entityTypes: [ENTITY_TYPE.EMPLOYEE, ENTITY_TYPE.ANY],
  },
  {
    path: '/scope/new',
    element: <ScopeDetail />,
    identifier: 'ui.admin.scopes',
    entityTypes: [ENTITY_TYPE.EMPLOYEE, ENTITY_TYPE.ANY],
  },
  {
    path: '/scope/detail/:id',
    element: <ScopeDetail />,
    identifier: 'ui.admin.scopes',
    entityTypes: [ENTITY_TYPE.EMPLOYEE, ENTITY_TYPE.ANY],
  },
  {
    path: '/functionalities',
    element: <FunctionalityList />,
    identifier: 'ui.admin.functionalities',
    entityTypes: [ENTITY_TYPE.EMPLOYEE, ENTITY_TYPE.ANY],
  },
  {
    path: '/functionality/detail/:id',
    element: <FunctionalityDetail />,
    identifier: 'ui.admin.functionalities',
    entityTypes: [ENTITY_TYPE.EMPLOYEE, ENTITY_TYPE.ANY],
  },
  {
    path: '/functionality/matrix',
    element: <ScopeFunctionalityMatrix />,
    identifier: 'ui.admin.functionality-matrix',
    entityTypes: [ENTITY_TYPE.EMPLOYEE, ENTITY_TYPE.ANY],
  },
  {
    path: '/timeOff',
    element: <TimeOff />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/timeOffHR',
    element: <TimeOff HRView={true} />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/timeOff/request',
    element: <TimeOffRequest HRView={false} />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/timeOff/requestHR',
    element: <TimeOffRequest HRView={true} />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/timeOffRequest/detail/:id',
    element: <TimeOffRequest HRView={false} />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/timeOffRequestHR/detail/:id',
    element: <TimeOffRequest HRView={true} />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/Calendar',
    element: <HRCalendar />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/CalendarHR',
    element: <HRCalendar HRView={true} />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/Calendar/Holidays',
    element: <HRCalendar />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/Calendar/Holidays/new',
    element: <HolidayPage />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/Calendar/Holidays/edit/:id',
    element: <HolidayPage />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/workflows',
    element: <Workflows />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/workflow/:id',
    element: <WorkflowAdmin />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/corporateEntities',
    element: <CorporateEntities />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/corporateEntities/new',
    element: <CorporateEntityDetail />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/corporateEntities/detail/:id',
    element: <CorporateEntityDetail />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/invoice-configuration',
    element: <InvoiceConfigurationPage />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
    scopes: ['corporateentity.edit'],
  },
  {
    path: '/taxes',
    element: <TaxList />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/accounts',
    element: <AccountList />,
    entityTypes: [ENTITY_TYPE.CORPORATE_ENTITY],
    scopes: ['account.read'],
  },
  {
    path: '/account/detail/:id',
    element: <AccountDetail />,
    entityTypes: [ENTITY_TYPE.CORPORATE_ENTITY],
    scopes: ['account.read'],
  },
  {
    path: '/account/detail/:accountId/reconcile/:seatId',
    element: <ReconciliationPage />,
    entityTypes: [ENTITY_TYPE.CORPORATE_ENTITY],
    scopes: ['account.read'],
  },
  {
    path: '/invoice-types',
    element: <InvoiceTypeList />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
    scopes: ['invoice.type.read'],
  },
  {
    path: '/regime',
    element: <Regime />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/regime/new',
    element: <RegimeNew />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/regime/:regimeId/types',
    element: <RegimeTypes />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/regime/:regimeId/types/new',
    element: <NewRegimeType />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/regime/:regimeId/types/edit/:typeId',
    element: <EditRegimeType />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/notifications',
    element: <Notifications />,
    entityTypes: [ENTITY_TYPE.ANY],
  },
  {
    path: '/translations',
    element: <TranslationsPage />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/ai-credits',
    element: <AiCreditPage />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/showcase/components',
    element: <ComponentsShowcase />,
    entityTypes: [ENTITY_TYPE.ANY],
  },
  {
    path: '/showcase/colors',
    element: <ColorsShowcase />,
    entityTypes: [ENTITY_TYPE.ANY],
  },
  {
    path: '/showcase/typography',
    element: <TypographyShowcase />,
    entityTypes: [ENTITY_TYPE.ANY],
  },
  {
    path: '/showcase/datagrid',
    element: <ShowcaseDataGrid />,
    entityTypes: [ENTITY_TYPE.ANY],
  },
  {
    path: '/myInvoices',
    element: <MyInvoices />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE, ENTITY_TYPE.PROVIDER],
  },
  {
    path: '/myInvoices/upload',
    element: <InvoiceUpload />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE, ENTITY_TYPE.PROVIDER],
  },
  {
    path: '/accountspayable',
    element: <InvoicesAccountsPayable />,
    entityTypes: [ENTITY_TYPE.CORPORATE_ENTITY],
  },
  {
    path: '/accountspayable/all',
    element: <InvoicesAccountsPayable />,
    entityTypes: [ENTITY_TYPE.CORPORATE_ENTITY],
  },
  {
    path: '/invoicing',
    element: <Invoicing />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE, ENTITY_TYPE.CORPORATE_ENTITY, ENTITY_TYPE.CLIENT],
  },
  {
    path: '/invoicing/newinvoice',
    element: <NewInvoicing />,
    entityTypes: [ENTITY_TYPE.CORPORATE_ENTITY],
  },
  {
    path: '/invoicing/detail/:id',
    element: <InvoicingDetail />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/invoice/detail/:id',
    element: <MyInvoiceDetail />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/accountspayable/validate/:id',
    element: <InvoiceDetailAccountsPayable onlyView={false} />,
    entityTypes: [ENTITY_TYPE.CORPORATE_ENTITY],
  },
  {
    path: '/accountspayable/detail/:id',
    element: <InvoiceDetailAccountsPayable onlyView={true} />,
    entityTypes: [ENTITY_TYPE.CORPORATE_ENTITY],
  },
  {
    path: '/notifications/configuration',
    element: <NotificationConfiguration />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/hr/training',
    element: <SkillsPage />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
    scopes: ['recruitment.manage'],
  },
  {
    path: '/hr/training-certifications',
    element: <TrainingCertificationsPage />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
    scopes: ['recruitment.manage'],
  },
  {
    path: '/hr/training-courses',
    element: <TrainingCoursesPage />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
    scopes: ['recruitment.manage'],
  },
  {
    path: '/hr/profiles',
    element: <ProfilesPage />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
    scopes: ['recruitment.manage'],
  },
  {
    path: '/hr/cv-configuration',
    element: <CvConfigurationPage />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
    scopes: ['recruitment.manage'],
  },
  {
    path: '/hr/job-openings',
    element: <JobOpeningsPage />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
    scopes: ['recruitment.manage'],
  },
  {
    path: '/hr/skill-matrix',
    element: <SkillMatrixPage />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
    scopes: ['recruitment.manage'],
  },
  {
    path: '/my-skills',
    element: <MySkillsPage />,
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
];

export default ROUTES;
